<h6>{{ title }}</h6>
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  [filterable]="true"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler()"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true"
>
  <ng-template kendoGridToolbarTemplate let-dataItem="dataItem">
    <button class="btn btn-primary" kendoGridAddCommand [hidden]="scope != 1">
      <fa-icon icon="plus"></fa-icon>
    </button>
  </ng-template>

  <kendo-grid-column
    field="Id"
    title="ID"
    width="100"
    [editable]="false"
    [hidden]="true">
  </kendo-grid-column>

  <kendo-grid-column
    field="ServiceId"
    title="Service ID"
    width="100"
    [editable]="false"
    [hidden]="true">
  </kendo-grid-column>

  <kendo-grid-column field="CategoryName" title="Category" [sortable]="false"> 
  </kendo-grid-column>

  <kendo-grid-column field="Name" title="Name"> 
  </kendo-grid-column>

  <kendo-grid-column field="IsLocked" title="Locked">  
  </kendo-grid-column>

  <kendo-grid-column field="EffectiveValue" [title]="scope === 1 ? 'Service Value' : 'Effective Value'">  
  </kendo-grid-column>

  <kendo-grid-command-column title="" width="120">
    <ng-template
      kendoGridCellTemplate
      let-isNew="isNew"
      let-dataItem="dataItem">
      <button class="btn btn-primary" kendoGridEditCommand>
        <fa-icon icon="external-link-alt"></fa-icon>
      </button>
      <button
        class="btn btn-danger"
        kendoGridRemoveCommand
        [hidden]="(scope == 2 && !dataItem.AllowEnvironmentOverride) || (scope == 3 && !dataItem.AllowTenantOverride)"
        [disabled]="(scope == 2 && dataItem.EnvironmentValue === undefined) || (scope == 3 && dataItem.TenantValue === undefined) || (dataItem.IsLocked === true)">
        <fa-icon icon="trash"></fa-icon>
      </button>      
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-service-configuration-key-detail 
  [model]="editItem" 
  [isNew]="isNew"
  [scope]="scope"
  [service]="service"
  [environmentService]="environmentService"
  [tenantEnvironment]="tenantEnvironment"
  [categories]="categories"
  (save)="saveHandler($event)"
  (cancel)="cancelHandler()">
</app-service-configuration-key-detail>
